var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container",attrs:{"role":"main"}},[_c('div',{staticClass:"row justify-content-center "},[_c('div',{staticClass:"col col-10 text-center"},[_c('h1',[_vm._v(_vm._s(_vm.name))])])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }